import React from "react";

function Chart({ stock }) {
  const image_url = "https://www.advfn.com/p.php?pid=staticchart&s=";
  if (stock) {
    return (
      <div className="d-block p-5 d-sm-flex">
        <div>
          <h5>1 Day Chart</h5>
          <img
            src={image_url.concat(
              stock,
              "&t=37&p=0&dm=0&vol=0&width=280&height=200&min_pre=0&min_after=0"
            )}
            alt="chart"
          />
        </div>
        <div>
          <h5>1 Year Chart</h5>
          <img
            src={image_url.concat(
              stock,
              "&t=37&p=5&dm=0&vol=0&width=280&height=200&min_pre=0&min_after=0"
            )}
            alt="chart"
          />
        </div>
      </div>
    );
  } else {
    return "";
  }
}

export default Chart;
